import React, { useEffect } from "react";
import { Router, Route, Link } from "react-router-dom";
import "reflect-metadata";

import { history } from "./helpers/history";
import { authenticationService } from "./services/authentication.service";

import "./App.css";
import "./assets/libs/admin-resources/jquery.vectormap/jquery-jvectormap-1.2.2.css";
import "./assets/css/modern/bootstrap-modern.css";
import "./assets/css/modern/app-modern.css";
import "./assets/css/icons.css";
import "./assets/libs/dropzone/min/dropzone.min.css";

import UnAuthLayout from "./layouts/unauth-layout";
import AuthLayout from "./layouts/auth-layout";

import { setApiToken } from "./helpers/setupApis";
import qs from "query-string";
import Token from "./models/Token";
import { Globals } from "./helpers/globals";

interface QueryParams {
    authUser?: string;
}

declare global {
    interface Crypto {
        randomUUID: () => string;
    }
}

console.log(crypto.randomUUID());

export {};

function App() {
    const currentUser = authenticationService.currentUserValue;
    const portal = authenticationService.portalValue;
    const query = qs.parse(location.search) as QueryParams;
    // 1. Set up the browser history with the updated location
    // (minus the # sign)
    const path = (/#!(\/.*)$/.exec(location.hash) || [])[1];
    if (path) {
        history.replace(path);
    }

    setApiToken();

    return (
        <Router history={history}>
            {currentUser && <AuthLayout />}
            {!currentUser && <UnAuthLayout />}
        </Router>
    );
}

export default App;
